import React, { useState } from "react";
import { Typography } from "@mui/material";
import FormTypes from "../components/Form2Types";
import AffectTypes from "../components/Affect2Types";
import Questions from "../components/Questions2";
import { useMsal } from "@azure/msal-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import ErrorCard from "../components/ErrorCard";
import SuccessCard from "../components/SuccessCard";

export default function Form() {
  // Request types
  // 0 - anonymous
  // 1 - unanonymous
  // 2 - ZHP account
  const [formType, setFormType] = useState(null);
  // Affects you
  // 0 - yes
  // 1 - no
  const [affectType, setAffectType] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { accounts } = useMsal();

  const navigate = useNavigate();

  const backNavigate = () => {
    if (formType === null && affectType === null) navigate("/formularze");
    if (formType !== null && affectType === null) setFormType(null);
    if (formType !== null && affectType !== null) setAffectType(null);
  };

  return (
    <>
      <Typography variant="h2">
        Zgłoszenie mobbingu w Głównej Kwaterze
      </Typography>
      <Typography
        component="span"
        variant="body1"
        onClick={() => backNavigate()}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          fontWeight: 500,
          cursor: "pointer",
          color: "#5d2f88",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        <ArrowBackIcon
          fontSize="inherit"
          sx={{ mr: 0.5, verticalAlign: "middle" }}
        />
        Poprzedni krok
      </Typography>
      {formType === null && affectType === null && (
        <Typography variant="body1">
          Wybierz w jaki sposób chcesz dokonać zgłoszenia mobbingu.
        </Typography>
      )}
      {error && <ErrorCard error={error} />}
      {success && (
        <SuccessCard
          alert={success.alert}
          description={success.description}
          pre={success.pre}
        />
      )}
      {formType === null && error === null && success === null && (
        <>
          <FormTypes account={accounts[0]} setFormType={setFormType} />
        </>
      )}
      {formType !== null &&
        affectType === null &&
        error === null &&
        success === null && (
          <>
            <AffectTypes setAffectType={setAffectType} />
          </>
        )}
      {formType !== null &&
        affectType !== null &&
        error === null &&
        success === null && (
          <>
            <Questions
              setError={setError}
              setSuccess={setSuccess}
              formType={formType}
              affectType={affectType}
            />
          </>
        )}
    </>
  );
}
